import moment from "moment"
import { app, api } from 'xadmin'
import _ from 'lodash'

function postRequest(body) {
  api({ name: `core/log` })
    .fetch('', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    .then(res => {
      console.log(res)
    })
    .catch(err => {
    })
}

async function addExporImportLog({ mode = 'export', data, schema, info, modelId, node, type: handleType }) {
  let modelNode, target
  try {
    const { user } = app.context.store.getState()
    // const _info = info || data
    const time = moment().format('YYYY-MM-DD HH:mm:ss')
    const _mode = (!mode || mode == 'export') ? '导出' : '导入'
    const diffInfo = user?.username + '于' + time + `:\n<span style=\"color: blue\">${_mode + data?.length}条数据</span>`
    if (modelId) {
      target = '模型'
      await api({ name: 'core/model/' }).fetch(modelId, {})
        .then(({ json }) => {
          modelNode = json
        })
    } else if (node) {
      target = '资产'
      modelNode = node

    } else {
      target = null
      modelNode = null
    }

    const logObj = modelNode ? { name: target + ':' + modelNode?.name } : {}

    const type = handleType || (target || schema?.name || schema?.title || '') + _mode
    const diff = diffInfo + (info ? JSON.stringify(info) : '')
    await postRequest({
      time,
      type,
      diff,
      data: { name: schema?.title || schema?.name || '' },
      logObj,
    })
  }
  catch (err) {
    console.log(err)
  }
}

export { addExporImportLog }
